<template>
  <div class="layout-container">
    <NavBar></NavBar>
    <div class="main-content">
      <!-- 美化后的导航菜单 -->
      <div class="sticky-nav">
        <el-menu
          :default-active="active"
          class="custom-menu"
          active-text-color="#2F66F3"
          background-color="#FFFFFF"
          mode="horizontal"
          router
        >
          <el-menu-item
            v-for="menu in menus"
            :key="menu.value"
            :index="menu.value"
            class="menu-item"
          >
            <i v-if="menu.icon" :class="menu.icon"></i>
            {{ menu.label }}
          </el-menu-item>

          <div class="refresh-btn" @click="refresh">
            <i class="el-icon-refresh"></i>
            <span>刷新</span>
          </div>
        </el-menu>
      </div>

      <!-- 内容区域 -->
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import {getPhone, getPortrait, getUserName, removeToken, setPortrait, setUserName} from '@/utils/auth'
import {getCosConfig, getPresignDownloadUrl, uploadImageFileByUserId} from '@/api/upload'
import {newUpdateUser, updateUser} from '@/api/user'
import Cos from 'cos-js-sdk-v5'
import {isMember, isMemberAdmin} from '@/api/member'
import NavBar from '@/layouts/NavBar.vue'

export default {
  name: 'UserLayout',
  components: {NavBar},
  data() {
    return {
      menus: [
        {label: '我的信息', value: '/mine/entrust', icon: 'el-icon-user'},
        {label: '子账户管理', value: '/mine/accountManagement', icon: 'el-icon-s-custom'},
        {label: '会员管理', value: '/mine/member', icon: 'el-icon-medal'},
        {label: '积分商城', value: '/mine/points-mall', icon: 'el-icon-shopping-cart-2'}
      ],
      height: '',
      userName: '',
      phone: '',
      portrait: '',
      dialogVisible: false,
      userDate: {
        username: '',
        portrait: []
      },
      imageUrl: ''
    }
  },
  computed: {
    active() {
      const result = this.menus.find(item => {
        return this.$route.path.indexOf(item.value) > -1
      })
      return result ? result.value : ''
    }
  },
  methods: {
    loginOut() {
      removeToken()
      this.$message.success('退出成功')
      setTimeout(() => {
        this.$router.push({name: 'wxLogin'})
      }, 1000)
    },

    customRequest(res) {
      this.disable = true

      // 1. 创建 FormData 对象
      const formData = new FormData()
      formData.append('imgFile', res.file)

      // 2. 上传文件到后端
      uploadImageFileByUserId(formData).then(response => {
        if (response.code === 200) {
          // 3. 后端返回的是 KEY（文件路径），不是完整URL
          const key = response.data  // 例如："20231220-12345-avatar.jpg"

          // 4. 获取签名下载链接（不能省略！）
          getPresignDownloadUrl(key).then(result => {
            console.log('签名URL:', result)

            // 5. 使用签名URL更新头像
            const signedUrl = result.data
            res.file.Location = signedUrl
            this.userDate.portrait[0] = {
              url: signedUrl
            }

            this.$emit('success', res.file)
            this.$message.success('上传成功')
          })
        } else {
          this.$message.error('上传失败')
        }
      }).catch(error => {
        console.error('上传失败:', error)
        this.$message.error('上传失败')
      }).finally(() => {
        this.disable = false
      })
    },
    // customRequest(res) {
    //   var time = new Date().getTime()
    //   this.disable = true
    //   const name = time + '-' + getUserId() + '-' + res.file.name
      // this.cosInstance.putObject(
      //   {
      //     Bucket: this.config.bucketName /* 必须 */,
      //     Region: this.config.region /* 存储桶所在地域，必须字段 */,
      //     Key: name /* 必须 */,
      //     Body: res.file, // 上传文件对象,
      //     StorageClass: 'STANDARD',
      //     onProgress: function (progressData) {
      //       console.log(JSON.stringify(progressData))
      //     }
      //   },
      //   (err, data) => {
      //     if (!err && data) {
      //       getPresignDownloadUrl(name).then(result => {
      //         console.log(result, 'res')
      //         res.file.Location = result.data
      //         this.userDate.portrait[0] = {
      //           url: result.data
      //         }
      //         this.$emit('success', res.file)
      //         this.$message.success('上传成功')
      //       })
      //     } else {
      //       this.$message.error('上传失败')
      //     }
      //     this.disable = false
      //   }
      // )
    // },

    uploadSuccess(res, file, filelist) {
      console.log('成功返回', filelist)
    },

    handleRemove(file, fileList) {
      this.userDate.portrait = fileList
    },

    save() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let formData = new FormData()
          formData.append('userName', this.userDate.username)
          if (this.userDate.portrait[0]) {
            formData.append('portrait', this.userDate.portrait[0].url)
            console.log(this.userDate.portrait[0].url, 'res')
          }
          newUpdateUser(formData).then(res => {
            if (res.code === 200) {
              setUserName(res.data.username)
              setPortrait(res.data.portrait)
              this.dialogVisible = false
              location.reload()
            } else {
              this.$message.error('修改失败')
            }
          })
        }
      })
    },

    judgeIsMemberAdmin() {
      isMemberAdmin().then(res => {
        if (res.code === 200 && res.data === false) {
          this.menus = this.menus.filter(item => item.value !== '/mine/accountManagement')
        }
      })
      isMember().then(res => {
        if (res.code === 200 && res.data === false) {
          this.menus = this.menus.filter(item => item.value !== '/mine/member')
        }
      })
    },

    refresh() {
      this.$message({
        message: '页面刷新中...',
        type: 'info'
      });
      setTimeout(() => {
        location.reload()
      }, 500);
    },

    update() {
      this.userDate.username = getUserName() !== 'null' && getUserName() ? getUserName() : ''
      this.userDate.portrait[0] = getPortrait() !== 'null' && getPortrait() ? {url: getPortrait()} : {}
      console.log(this.userDate.portrait[0], 'ddd')
      this.dialogVisible = true
    }
  },
  created() {
    this.userName = getUserName() !== 'null' && getUserName() ? getUserName() : '点击完善您的个人信息'
    this.phone = getPhone(true)
    this.portrait = getPortrait()
    if (getPortrait()) {
      this.userDate.portrait[0] = {
        url: getPortrait()
      }
    }
    getCosConfig().then(res => {
      this.config = res.data
    })
    this.cosInstance = new Cos({
      Protocol: 'https:',
      getAuthorization: (options, callback) => {
        getCosConfig().then(res => {
          this.config = res.data
          const data = res.data
          callback({
            TmpSecretId: data.secretId,
            TmpSecretKey: data.secretKey,
            XCosSecurityToken: data.token,
            StartTime: data.StartTime,
            ExpiredTime: data.expiredTime
          })
        })
      }
    })
    this.judgeIsMemberAdmin()
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 5xp;
  background: url(../../static/index/background.png);
}

.sticky-nav {
  width:1250px;
  border-radius: 8px;
  margin: 0 auto;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: white;
}

.custom-menu {
  max-width: 1200px;
  margin: 0 auto;
  border-bottom: none !important;
  display: flex;
  justify-content: center;

  .menu-item {
    padding: 0 25px;
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.3s ease;

    i {
      margin-right: 8px;
      font-size: 16px;
    }

    &:hover {
      color: #2F66F3 !important;
      background-color: #f0f5ff !important;
    }

    &.is-active {
      border-bottom: 3px solid #2F66F3 !important;
    }
  }
}

.refresh-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding: 8px 15px;
  border-radius: 4px;
  color: #646C7A;
  cursor: pointer;
  transition: all 0.3s;

  i {
    margin-right: 5px;
    font-size: 16px;
  }

  &:hover {
    color: #2F66F3;
    background-color: #f0f5ff;
  }
}

.content-wrapper {
  flex: 1;
  max-width: 1210px;
  width: 100%;
  margin: 5px auto;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .custom-menu {
    justify-content: flex-start;
    overflow-x: auto;
    padding: 0 10px;

    .menu-item {
      padding: 0 15px;
      font-size: 14px;
    }

    .refresh-btn {
      position: relative;
      right: auto;
      top: auto;
      transform: none;
      margin-left: auto;
      padding: 0 10px;
    }
  }

  .content-wrapper {
    padding: 15px;
    margin: 10px auto;
  }
}

/* 动画效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/layouts/MineLayout.vue